import gsap from 'gsap';

// From https://codepen.io/ccrch/pen/yyaraz
export const ReverseTrackingHover = (scaleAmount = 1.5) => ({
    init() {
        const img = this.$el.querySelector('img');
        const onHover = (event) => {
            gsap.to(img, {
                duration: scaleAmount,
                ease: 'power4.out',
                scale: event.type === 'mouseover' ? scaleAmount : 1,
            })
        }

        const onMove = (event) => {
            const tile = event.currentTarget
            const container = tile.parentElement
            const x = event.clientX
            const y = event.clientY

            gsap.set(img, {
                transformOrigin: `${((x - tile.offsetLeft - container.getBoundingClientRect().left) / img.offsetWidth) * 100}% ${((y - tile.offsetTop - container.getBoundingClientRect().top) / img.offsetHeight) * 100}%`,
            })
        }


        this.$el.addEventListener('mouseover', onHover);
        this.$el.addEventListener('mouseout', onHover);
        this.$el.addEventListener('mousemove', onMove);
    }
});
